import { Navigate, useLocation } from "react-router-dom";

const canonicalizePathname = (pathname: string) => {
  if (!pathname) return "/";
  const singleSlash = pathname.replace(/\/{2,}/g, "/");
  if (singleSlash.startsWith("/")) {
    return singleSlash || "/";
  }
  return `/${singleSlash}`;
};

const RoutePathNormalizer = () => {
  const location = useLocation();
  const canonicalPathname = canonicalizePathname(location.pathname);

  if (canonicalPathname === location.pathname) {
    return null;
  }

  return (
    <Navigate
      to={`${canonicalPathname}${location.search}${location.hash}`}
      replace
      state={location.state}
    />
  );
};

export default RoutePathNormalizer;
